import { render, staticRenderFns } from "./HelpAdmin.vue?vue&type=template&id=0dd8b926&scoped=true"
import script from "./HelpAdmin.vue?vue&type=script&lang=js"
export * from "./HelpAdmin.vue?vue&type=script&lang=js"
import style0 from "./HelpAdmin.vue?vue&type=style&index=0&id=0dd8b926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8b926",
  null
  
)

export default component.exports